"use client"
import AboutSection from "@/components/(home)/AboutSection";
import BannerArea from "@/components/(home)/BannerArea";
import BlogSection from "@/components/(home)/BlogSection";
import SliderSection from "@/components/(home)/SliderSection";
import UpComingEvent from "@/components/(home)/UpComingEvent";
import WhatWedoSection from "@/components/(home)/WhatWedoSection";
import { useLanguage } from "@/context/LanguageContext";
import { Fragment } from "react";

export default function Home() {
  const { lang, t, switchLanguage } = useLanguage();

  if (!lang) {
    // Ajout d'une UI temporaire pendant le chargement de la langue
    return <div>Loading...</div>;
  }

  return (
    <Fragment>
      <SliderSection/>
      <WhatWedoSection/>
      <AboutSection/>
      <UpComingEvent/>
      <BannerArea/>
      <BlogSection/>
    </Fragment>
  );
}
